const flickrApiKey = '2805b8d49efdd709b6a4d1e09a39565d';
export default flickrApiKey;